import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles, useToolbarStyles } from './EstoqueInsumoMovimentacaoTableStyles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import theme from '../../../../theme';
import Grid from '@material-ui/core/Grid';


function EstoqueMovimentacoeMovimentacaoTable(props) {
  const { movimentacoes, setMovimentacoes, titulo, mensagemSemDados} = props;
  const classes = useStyles();


  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" color="textSecondary" gutterBottom id='tituloTabelaEstoqueMovimentacao'>
          { titulo }
        </Typography>
      </Toolbar>
    );
  };

  return (
    <Paper
      className={classes.root}
      elevation={3}
    >
      <Grid
        container
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <EnhancedTableToolbar numSelected={0} />
        </Grid>
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length <= 0 &&
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <img
              height={'170px'}
              width={'220px'}
              alt="Logo"
              src={"/images/erroGeral.png"}
              style={{
                marginTop: 10,
                marginBottom: 10
              }}
            />
          </Grid>
        }
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length <= 0 &&
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Typography className={classes.title} variant="h4" color="textSecondary" gutterBottom id='tituloTabelaEstoqueMovimentacao'>
              { mensagemSemDados }
            </Typography>
          </Grid>
        }
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length > 0 &&
          <Grid
            item
            md={12}
            xs={12}
          >
            <TableContainer className={classes.containerTable}>
              <Table
                stickyHeader
                aria-label="sticky table"
                size={'small'}
              >
                <TableHead
                >
                  <TableRow
                  >
                    <TableCell
                      key={'label_insumo'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                    </TableCell>
                    <TableCell
                      key={'label_numero_mov'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      Nº
                    </TableCell>
                    <TableCell
                      key={'label_descricao_insumo'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Insumo'}
                    </TableCell>

                    <TableCell
                      key={'label_descricao'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Descrição'}
                    </TableCell>
                    <TableCell
                      key={'label_data'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Data'}
                    </TableCell>
                    <TableCell
                      key={'label_tipo'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Tipo'}
                    </TableCell>
                    <TableCell
                      key={'label_quantidade_anterior'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Antes'}
                    </TableCell>
                    <TableCell
                      key={'label_quantidade'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Quantidade'}

                    </TableCell>
                    <TableCell
                      key={'label_quantidade_atual'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Depois'}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movimentacoes.result.map((movimentacao, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={movimentacao.idEstoqueInsumoMovimentacao}
                      >
                        <TableCell
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.tipoMovimentacao === 'N' ?
                              <Tooltip title="Saída negativa">
                                <IconButton
                                  aria-label="filter list"
                                >
                                  <HighlightOffIcon
                                    style={{
                                      color: theme.palette.error.main
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              :
                              <Tooltip title="Saída positiva">
                                <IconButton
                                  aria-label="filter list"
                                >
                                  <CheckCircleOutlineIcon
                                    style={{
                                      color: theme.palette.success.main
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                          }
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {movimentacao.estoqueInsumo && movimentacao.estoqueInsumo.insumo && movimentacao.estoqueInsumo.insumo.descricao}
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {movimentacao.descricao || 'Não informado'}
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {moment(movimentacao.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {(movimentacao.tipoMovimentacao &&
                            (movimentacao.tipoMovimentacao === 'N' ? 'Saída' : 'Entrada')) ||
                          'Não identificado'
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.quantidadeAnterior
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.quantidade
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.quantidadeAtual
                          }
                        </TableCell>

                      </TableRow>

                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        }
      </Grid>
    </Paper>
  );
};

export default EstoqueMovimentacoeMovimentacaoTable;
